var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import helpActionTypes from "./HelpActionTypes.js";
import { getDefaultAsyncWrapperObj, AsyncRequestStatus, getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import { loadExperimentationGroupsEpicReducer } from "../epics/HelpEpics.js";
var OperationStatus = /* @__PURE__ */ ((OperationStatus2) => {
  OperationStatus2[OperationStatus2["NoOp"] = 0] = "NoOp";
  OperationStatus2[OperationStatus2["Initiated"] = 1] = "Initiated";
  OperationStatus2[OperationStatus2["Success"] = 2] = "Success";
  OperationStatus2[OperationStatus2["Failure"] = 3] = "Failure";
  return OperationStatus2;
})(OperationStatus || {});
const getDefaultState = {
  categories: void 0,
  ticketCreationError: false,
  deleteFlightStatus: 0,
  flightData: void 0,
  getFlightStatus: 0,
  creatingTicket: false,
  managementGroups: void 0,
  managementGroupUpdated: false,
  experimentationGroups: getDefaultAsyncWrapperObj(),
  mdsFlightControl: void 0,
  createdTicket: void 0,
  uploadUserFile: getDefaultAsyncWrapperObj()
};
const HelpReducer = (state = getDefaultState, actionResult) => {
  state = loadExperimentationGroupsEpicReducer.reduxChange(state, actionResult);
  switch (actionResult.type) {
    case helpActionTypes.CREATE_TICKET:
      return __spreadProps(__spreadValues({}, state), {
        creatingTicket: true
      });
    case helpActionTypes.CREATED_TICKET:
      return __spreadProps(__spreadValues({}, state), {
        ticketCreationError: "Error" in actionResult.payload,
        createdTicket: actionResult.payload,
        creatingTicket: false
      });
    case helpActionTypes.UPLOAD_USER_FILE:
      return __spreadProps(__spreadValues({}, state), {
        uploadUserFile: {
          status: AsyncRequestStatus.Pending,
          data: null,
          error: null
        }
      });
    case helpActionTypes.UPLOADED_USER_FILE:
      return __spreadProps(__spreadValues({}, state), {
        uploadUserFile: getCompletedAsyncWrapperObj(
          actionResult.payload,
          !actionResult.payload || actionResult.payload.length === 0 ? "error" : ""
        )
      });
    case helpActionTypes.LOADED_MGMT_GRPS:
      return __spreadProps(__spreadValues({}, state), {
        managementGroups: actionResult.payload
      });
    case helpActionTypes.LOAD_FLIGHT_DATA:
      return __spreadProps(__spreadValues({}, state), {
        getFlightStatus: 1
        /* Initiated */
      });
    case helpActionTypes.LOADED_FLIGHT_DATA:
      const actionResultCast = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        flightData: actionResultCast.payload.data,
        getFlightStatus: actionResultCast.payload.status === AsyncRequestStatus.Completed ? 2 : 3
        /* Failure */
      });
    case helpActionTypes.DELETE_FLIGHT:
      return __spreadProps(__spreadValues({}, state), {
        deleteFlightStatus: 1
        /* Initiated */
      });
    case helpActionTypes.DELETED_FLIGHT:
      return __spreadProps(__spreadValues({}, state), {
        deleteFlightStatus: actionResult.payload === Object(actionResult.payload) && ("Error" in actionResult.payload || "Message" in actionResult.payload) ? 3 : 2
        /* Success */
      });
    case helpActionTypes.LOADED_MDS_FLIGHT_CONTROL:
      return __spreadProps(__spreadValues({}, state), {
        mdsFlightControl: actionResult.payload
      });
    case helpActionTypes.CHANGED_MG:
      return __spreadProps(__spreadValues({}, state), {
        managementGroupUpdated: true
      });
    case helpActionTypes.LOADED_CATEGORIES:
      return __spreadProps(__spreadValues({}, state), {
        categories: actionResult.payload
      });
    case helpActionTypes.CLEAR_UPLOADED_FILE_CACHE:
      return __spreadProps(__spreadValues({}, state), {
        uploadUserFile: {
          status: AsyncRequestStatus.NotStarted,
          data: null,
          error: null
        }
      });
    default:
      return state;
  }
};
export {
  HelpReducer,
  OperationStatus,
  HelpReducer as default
};
//# sourceMappingURL=HelpReducer.js.map
